import type { Accent } from '../types/content'

export const accentDot: Record<Accent, string> = {
  sage: 'bg-sage',
  dusty: 'bg-dusty',
  terra: 'bg-terra',
  gold: 'bg-gold',
}

export const accentWash: Record<Accent, string> = {
  sage: 'bg-sage-wash',
  dusty: 'bg-dusty-wash',
  terra: 'bg-terra-wash',
  gold: 'bg-gold-wash',
}

export const accentText: Record<Accent, string> = {
  sage: 'text-sage-deep',
  dusty: 'text-dusty-deep',
  terra: 'text-terra-dark',
  gold: 'text-gold-deep',
}
